"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBase64UrlToArrayBuffer = exports.convertArrayBufferToBase64Url = void 0;
var convertArrayBufferToBase64Url_1 = require("./convertArrayBufferToBase64Url");
Object.defineProperty(exports, "convertArrayBufferToBase64Url", { enumerable: true, get: function () { return convertArrayBufferToBase64Url_1.convertArrayBufferToBase64Url; } });
var convertBase64UrlToArrayBuffer_1 = require("./convertBase64UrlToArrayBuffer");
Object.defineProperty(exports, "convertBase64UrlToArrayBuffer", { enumerable: true, get: function () { return convertBase64UrlToArrayBuffer_1.convertBase64UrlToArrayBuffer; } });
